import { cn } from "../../lib/utils";
import { SECTION_BOXES, compileSections, type OutcomeSections } from "./outcome-sections";

export const DESCRIPTION_LIMIT = 4000;

// The four boxes of a new outcome. Allowed values and the type keep their own controls above, so the
// boxes do not repeat them. The server builds the text PCA reads from these boxes.
export function OutcomeSectionsEditor({
  value,
  onChange,
  idPrefix,
}: {
  value: OutcomeSections;
  onChange: (next: OutcomeSections) => void;
  idPrefix: string;
}) {
  const built = compileSections(value).length;
  return (
    <div className="mt-3 grid gap-3" data-testid="outcome-four-boxes">
      {SECTION_BOXES.map((box) => {
        const text = value[box.key] || "";
        const id = `${idPrefix}-${box.key}`;
        return (
          <label key={box.key} htmlFor={id} className="block">
            <span className="mb-1.5 flex justify-between text-[11px] font-bold text-ink-2">
              {box.label}
              <span className={cn("font-mono font-normal", text.length >= box.max ? "text-danger" : "text-ink-3")}>
                {text.length}/{box.max}
              </span>
            </span>
            <textarea
              id={id}
              rows={box.rows}
              maxLength={box.max}
              value={text}
              onChange={(event) => onChange({ ...value, [box.key]: event.target.value })}
              placeholder={box.hint}
              className="w-full resize-y rounded-md border border-line bg-elevated px-3 py-2 text-sm outline-none focus:border-brand"
            />
          </label>
        );
      })}
      <p className="text-[11px] text-ink-3">
        The description the analysis reads is built from these boxes: {built}/{DESCRIPTION_LIMIT} characters.
      </p>
    </div>
  );
}
